import { Button, styled } from "@mui/material";

const MainButton = styled(Button)(({ theme }) => ({
  textTransform: "capitalize",
  fontFamily: "Montserrat",
  fontSize: "var(--small-font-size)",
  color: "#fff",
  whiteSpace: "nowrap",
  gap: "10px",

  "&:disabled": {
    cursor: "not-allowed",
    opacity: 0.5,
  },

  // Variant: primary
  "&.primary": {
    backgroundColor: theme.palette.primary.main,

    "&:hover": {
      opacity: 0.8,
    },

    "&.no-fill": {
      backgroundColor: "#fff",
      color: theme.palette.primary.main,
      border: `2px solid ${theme.palette.primary.main}`,
    },
  },

  // Variant: secondary
  "&.secondary": {
    backgroundColor: theme.palette.secondary.main,

    "&:hover": {
      opacity: 0.8,
    },

    "&.noFill": {
      backgroundColor: "transparent",
      color: theme.palette.secondary.main,
      border: `2px solid ${theme.palette.secondary.main}`,

      svg: {
        "*": {
          fill: theme.palette.secondary.main,
        },
      },

      "&.important-link": {
        color: "red",
        fontWeight: 700,
        border: "5px solid red",

        svg: {
          "*": {
            fill: "red",
          },
        },
      },
    },
  },

  // Variant: course
  "&.course": {
    backgroundColor: "#f6f6f6",
    color: "#000",

    "&.clicked": {
      backgroundColor: "#c9ccd5",
    },
  },
}));

export default MainButton;
